import { LocaleUser } from '../en/user'

const user: LocaleUser = {
  changePass: 'Đổi mật khẩu',
  editProfile: 'Chỉnh Sửa Hồ Sơ',
  emailVerifiedSuccess: 'Xác minh email thành công.',
  emailCantVerified: 'Email của bạn không thể được xác minh.',
  changeLang: 'Thay đổi ngôn ngữ',
  english: 'Tiếng Anh',
  vietnamese: 'Tiếng Việt',
  chineseSimplified: 'Tiếng Trung (Giản thể)',
  spanish: 'Tiếng Tây Ban Nha',
  chineseTraditional: 'Tiếng Trung (Phồn thể)',
  malay: 'Tiếng Mã Lai',
}

export default user
